module.exports = __webpack_public_path__ + "img/bl.cb373b87.svg";